<template>
  <div id="claim-report-view">
    <vs-row style="flex-wrap: wrap-reverse">
      <vs-col vs-lg="9" vs-sm="12">
        <div class="title-area mb-6">
          <template v-if="isInsuranceCompany">
            <div class="edit-title-input-area mr-3" v-if="isEditTitle">
              <vs-input class="title-input" v-model="titleInput" />
              <common-button
                class="button px-2"
                title="保存"
                :click="() => callUpdateTitle(titleInput)"
                :disabled="!isTitleInputValidated"
              ></common-button>
              <common-button
                class="button px-2"
                title="キャンセル"
                :click="() => cancelEditTitle()"
                color="#BDBDBD"
                text-color="#757575"
                type="border"
              ></common-button>
            </div>
            <div v-else class="title-text" @click="isEditTitle = true">
              <common-text-large :text="getClaimReportTitle" />
            </div>
          </template>
          <template v-else>
            <common-text-large :text="getClaimReportTitle" />
          </template>

          <div class="action-button-area">
            <status-dropdown-select
              v-if="isStatusSelectable"
              :options="claimReportStatusOptions"
              :value.sync="claimReportStatus"
              :onClickOption="openConfirmUpdateStatusModal"
              clickEvent
            ></status-dropdown-select>
            <status-chip
              v-else
              :label="claimReportStatus.label"
              :color="claimReportStatus.color"
            ></status-chip>
            <feather-icon
              v-if="isInsuranceCompany"
              icon="Trash2Icon"
              class="trash-icon-button ml-6"
              svgClasses="h-6 w-6"
              @click="openDeleteModal"
            />
          </div>
        </div>

        <div class="tab-container">
          <div ref="tabScrollArea" class="tab-button-area">
            <div
              class="tab-button"
              v-for="(tab, index) in tabs"
              :key="index"
              :class="{
                active: activeTab === index,
                inactive: activeTab !== index,
              }"
              @click="setActiveTab(index)"
            >
              {{ tab.title }}
            </div>
            <div
              v-if="showAddTabButton"
              class="tab-add-button"
              @click="onClickAddTab()"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            </div>
          </div>
          <div class="tab-content">
            <claim-summary
              v-if="activeTab === 0"
              :insurerEnterpriseId="insurerEnterpriseId"
              :ownerEnterpriseId="ownerEnterpriseId"
            ></claim-summary>
            <claim-staffs v-else-if="activeTab === 1"></claim-staffs>
            <div v-else-if="tabs[activeTab].static">
              <common-text-medium class="mb-2" text="損種(必要情報)" />
              <hull-dropdown-select
                class="filter-input mb-6"
                :selectOptions="filteredClaimTypeOptions"
                :onSelect="onSelectAddClaimType"
                :selectedValue="selectedAddClaimType"
                placeholder="損種"
                bordered
                :isSearchable="true"
              ></hull-dropdown-select>

              <div
                v-for="(step, index) in selectedAddClaimTypeSteps"
                :key="index"
              >
                <vs-divider class="my-0"></vs-divider>
                <common-text-medium class="mt-5" :text="step.name" />
                <div
                  class="my-5"
                  v-for="(claimReportTypeStepItem,
                  index) in step.claim_type_step_items"
                  :key="index"
                >
                  <!-- 一行テキスト -->
                  <form-one-line-text
                    v-if="claimReportTypeStepItem.claim_item.input_type == 1"
                    :title="claimReportTypeStepItem.claim_item.name"
                    preview
                  ></form-one-line-text>
                  <!-- 段落テキスト -->
                  <form-multi-line-text
                    v-else-if="
                      claimReportTypeStepItem.claim_item.input_type == 2
                    "
                    :title="claimReportTypeStepItem.claim_item.name"
                    preview
                  ></form-multi-line-text>
                  <!-- ファイル添付 -->
                  <form-file-manager
                    v-if="claimReportTypeStepItem.claim_item.input_type == 3"
                    :title="claimReportTypeStepItem.claim_item.name"
                    preview
                  ></form-file-manager>
                  <!-- チェックボックス -->
                  <form-check-box
                    v-else-if="
                      claimReportTypeStepItem.claim_item.input_type == 4
                    "
                    :title="claimReportTypeStepItem.claim_item.name"
                    :options="claimReportTypeStepItem.claim_item.choices"
                    preview
                  ></form-check-box>
                  <!-- プルダウン -->
                  <form-dropdown-select
                    v-else-if="
                      claimReportTypeStepItem.claim_item.input_type == 5
                    "
                    :title="claimReportTypeStepItem.claim_item.name"
                    :options="claimReportTypeStepItem.claim_item.choices"
                    preview
                  ></form-dropdown-select>
                  <!-- ラジオボタン -->
                  <form-radio-button
                    v-else-if="
                      claimReportTypeStepItem.claim_item.input_type == 6
                    "
                    :title="claimReportTypeStepItem.claim_item.name"
                    :options="claimReportTypeStepItem.claim_item.choices"
                    preview
                  ></form-radio-button>
                  <!-- 連絡先 -->
                  <form-contact
                    v-if="claimReportTypeStepItem.claim_item.input_type == 7"
                    :title="claimReportTypeStepItem.claim_item.name"
                    preview
                  ></form-contact>
                  <!-- リンク -->
                  <form-link
                    v-else-if="
                      claimReportTypeStepItem.claim_item.input_type == 8
                    "
                    :title="claimReportTypeStepItem.claim_item.name"
                    preview
                  ></form-link>
                  <!-- 日付 -->
                  <form-date
                    v-else-if="
                      claimReportTypeStepItem.claim_item.input_type == 9
                    "
                    :title="claimReportTypeStepItem.claim_item.name"
                    preview
                  ></form-date>
                  <!-- 時間 -->
                  <form-time
                    v-else-if="
                      claimReportTypeStepItem.claim_item.input_type == 10
                    "
                    :title="claimReportTypeStepItem.claim_item.name"
                    preview
                  ></form-time>
                  <!-- 位置情報 -->
                  <form-coordinates
                    v-else-if="
                      claimReportTypeStepItem.claim_item.input_type == 11
                    "
                    :title="claimReportTypeStepItem.claim_item.name"
                    preview
                  ></form-coordinates>
                  <!-- 金額 -->
                  <form-price
                    v-else-if="
                      claimReportTypeStepItem.claim_item.input_type == 12
                    "
                    :title="claimReportTypeStepItem.claim_item.name"
                    preview
                    selectPlaceholder="円"
                    textPlaceholder="金額"
                  ></form-price>
                  <!-- 単位 -->
                  <form-unit
                    v-else-if="
                      claimReportTypeStepItem.claim_item.input_type == 13
                    "
                    :title="claimReportTypeStepItem.claim_item.name"
                    preview
                    selectPlaceholder="G/T"
                    textPlaceholder="総トン数(G/T)"
                  ></form-unit>
                </div>
              </div>

              <div>
                <div class="button-area">
                  <common-button
                    class="button"
                    title="キャンセル"
                    :click="addTabCancel"
                    color="#BDBDBD"
                    text-color="#757575"
                    type="border"
                  ></common-button>
                  <common-button
                    class="button"
                    title="登録"
                    :click="onClickAddReportClaimType"
                    :disabled="selectedAddClaimType == null"
                  ></common-button>
                </div>
              </div>
            </div>
            <div v-else>
              <claim-type-form
                :preview="false"
                :claimReportId="claimReportId"
                :claimReportTypeId="tabs[activeTab].claimReportTypeId"
                :refreshData="callFetch"
                :key="activeTab + tabs[activeTab].claimReportTypeId"
                :claimTypeOptions="filteredClaimTypeOptions"
                :enterpriseKind="enterpriseKind"
                :mandatoryItemFilledData.sync="mandatoryItemFilledData"
                :insurerEnterpriseId="insurerEnterpriseId"
                :ownerEnterpriseId="ownerEnterpriseId"
              ></claim-type-form>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col class="right-widget-area" vs-lg="3" vs-sm="12">
        <hull-navigation-select
          v-if="enterpriseKind == 2"
          class="mb-4"
          menuButtonLabel="メニュー"
          :menuItemOptions="getMenuItemOptions(this.$route.name)"
        >
        </hull-navigation-select>
        <input-filled-count-label
          v-for="(item, index) in mandatoryItemFilledData"
          :key="index"
          :itemLabel="item.name"
          :number="item.number"
          :maxNumber="item.maxNumber"
          class="my-4"
        ></input-filled-count-label>
      </vs-col>
    </vs-row>
    <common-modal title="" ref="DeleteModal">
      <template v-slot:contents>
        <div class="delete-container">
          事故を削除しますか？
          <div class="button-area">
            <common-button
              class="button"
              title="キャンセル"
              :click="closeDeleteModal"
              color="#BDBDBD"
              text-color="#757575"
              type="border"
            ></common-button>
            <common-button
              class="button"
              title="削除"
              :click="() => callDelete()"
            ></common-button>
          </div>
        </div>
      </template>
    </common-modal>
    <common-modal title="" ref="ClaimTypeAddConfirmModal">
      <template v-slot:contents>
        <div class="claim-type-add-confirm-container">
          1つ目の損種を登録すると、関係者に通知が送信されます。
          <div class="button-area">
            <common-button
              class="button"
              title="キャンセル"
              :click="closeClaimTypeAddConfirmModal"
              color="#BDBDBD"
              text-color="#757575"
              type="border"
            ></common-button>
            <common-button
              class="button"
              title="登録"
              :click="
                () => {
                  closeClaimTypeAddConfirmModal();
                  callAddReportClaimType();
                }
              "
            ></common-button>
          </div>
        </div>
      </template>
    </common-modal>
    <common-modal title="" ref="ConfirmUpdateStatusModal">
      <template v-slot:contents>
        <div class="delete-container">
          事故対応ステータスを変更すると、関係者に通知が送信されます。
          <div class="button-area">
            <common-button
              class="button"
              title="キャンセル"
              :click="closeConfirmUpdateStatusModal"
              color="#BDBDBD"
              text-color="#757575"
              type="border"
            ></common-button>
            <common-button
              class="button"
              title="変更"
              :click="() => updateClaimReportStatus(claimReportStatusChangeTo)"
            ></common-button>
          </div>
        </div>
      </template>
    </common-modal>
  </div>
</template>

<script>
import { ColorMixin, HullInsranceMixin } from "@/mixins";
import CommonTextMedium from "../components/atoms/CommonTextMedium.vue";
import CommonTextLarge from "../components/atoms/CommonTextLarge.vue";
import CommonButton from "../components/molecules/CommonButton.vue";
import CommonModal from "../components/organisms/CommonModal.vue";
import InputFilledCountLabel from "../components/molecules/InputFilledCountLabel.vue";
import HullDropdownSelect from "../components/molecules/HullDropdownSelect.vue";
import HullNavigationSelect from "../components/molecules/HullNavigationSelect.vue";
import StatusChip from "../components/molecules/StatusChip.vue";
import StatusDropdownSelect from "../components/organisms/StatusDropdownSelect.vue";

import ClaimStaffs from "./components/ClaimStaffs.vue";
import ClaimSummary from "./components/ClaimSummary.vue";
import ClaimTypeForm from "./components/ClaimTypeForm.vue";

import FormOneLineText from "../components/organisms/FormOneLineText.vue";
import FormMultiLineText from "../components/organisms/FormMultiLineText.vue";
import FormCheckBox from "../components/organisms/FormCheckBox.vue";
import FormFileManager from "../components/organisms/FormFileManager.vue";
import FormDropdownSelect from "../components/organisms/FormDropdownSelect.vue";
import FormRadioButton from "../components/organisms/FormRadioButton.vue";
import FormContact from "../components/organisms/FormContact.vue";
import FormLink from "../components/organisms/FormLink.vue";
import FormPrice from "../components/organisms/FormPrice.vue";
import FormUnit from "../components/organisms/FormUnit.vue";
import FormCoordinates from "../components/organisms/FormCoordinates.vue";
import FormTime from "../components/organisms/FormTime.vue";
import FormDate from "../components/organisms/FormDate.vue";

import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import { HULL_INSURANCE_CLAIM_REPORT_STATUS_LABEL } from "@/config/const";

const claimReportRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseClaimReport"
);
const claimReportClaimTypeRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseReportClaimType"
);
const claimTypeRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseClaimType"
);
const enterpriseKindRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseEnterpriseKind"
);

export default {
  name: "T.ClaimReportView",
  mixins: [ColorMixin, HullInsranceMixin],
  components: {
    CommonTextMedium,
    CommonTextLarge,
    CommonButton,
    CommonModal,
    InputFilledCountLabel,
    ClaimStaffs,
    ClaimSummary,
    HullDropdownSelect,
    HullNavigationSelect,
    ClaimTypeForm,
    StatusChip,
    StatusDropdownSelect,
    FormOneLineText,
    FormMultiLineText,
    FormCheckBox,
    FormFileManager,
    FormDropdownSelect,
    FormRadioButton,
    FormContact,
    FormLink,
    FormPrice,
    FormUnit,
    FormCoordinates,
    FormTime,
    FormDate,
  },
  data() {
    return {
      enterpriseKind: null,
      claimReportId: null,

      insurerEnterpriseId: null,
      ownerEnterpriseId: null,

      overviewTitle: null,
      overviewStatus: null,

      titleInput: "",
      claimReportStatus: { label: null, color: null, value: null },
      claimReportStatusChangeTo: null,

      isEditTitle: false,

      claimReportClaimTypes: [],

      completedClaimTypes: [],

      mandatoryItemFilledData: [],

      selectedAddClaimType: null,

      activeTab: 0,
      tabs: [
        { title: "事故概要", static: true },
        { title: "関係者情報", static: true },
      ],

      showAdditionalTab: false,
    };
  },
  async created() {
    this.claimReportId = this.$route.params.id;
    this.enterpriseKind = await this.getEnterpriseKind();
    await this.fetchEnterpriseId();
    this.callFetch();
  },
  computed: {
    filteredClaimTypeOptions() {
      return this.completedClaimTypes
        .filter(type =>
          this.tabs.map(tab => tab.claimTypeId).every(id => id !== type.id)
        )
        .map(element => {
          return {
            text: element.name,
            value: element.id,
          };
        });
    },
    selectedAddClaimTypeSteps() {
      const type = this.completedClaimTypes.find(
        element => element.id == this.selectedAddClaimType
      );
      if (type != null) {
        return type.claim_type_steps;
      } else {
        return [];
      }
    },
    isStatusSelectable() {
      if (!this.claimReportStatus || !this.claimReportStatus.value) return;
      return this.claimReportStatus.value != 1 && this.isInsuranceCompany;
    },
    isVesselOwner() {
      return this.enterpriseKind == 1;
    },
    isInsuranceCompany() {
      return this.enterpriseKind == 2;
    },
    inputFilledCountList() {
      return this.$store.state.hullInsuranceReportView.inputFilledCountList;
    },
    isTitleInputValidated() {
      return this.titleInput.trim().length > 0;
    },
    getClaimReportTitle() {
      return this.overviewTitle ? this.overviewTitle.input_values : "";
    },
    showAddTabButton() {
      if (this.enterpriseKind == 1) {
        return false;
      } else {
        return !this.showAdditionalTab;
      }
    },
    claimReportStatusOptions() {
      return Object.values(HULL_INSURANCE_CLAIM_REPORT_STATUS_LABEL).filter(
        element =>
          element.value != 1 && element.value != this.claimReportStatus.value
      );
    },
  },
  methods: {
    tabScrollToRight() {
      const tabScrollArea = this.$refs.tabScrollArea;
      tabScrollArea.scrollLeft =
        tabScrollArea.scrollWidth - tabScrollArea.clientWidth;
    },
    cancelEditTitle() {
      this.isEditTitle = false;
      this.titleInput = this.overviewTitle.input_values;
    },
    initializeTabs() {
      this.tabs = [
        { title: "事故概要", static: true },
        { title: "関係者情報", static: true },
      ];
    },
    onSelectAddClaimType(value) {
      this.selectedAddClaimType = value;
    },
    setActiveTab(index) {
      this.clearMandatoryItemFilledData();

      this.activeTab = index;
      if (!this.tabs[index].static) {
        this.callFetch();
      }
      // 事故概要タブを開いた時に損種タブの入力状況を取得
      if (index == 0) {
        this.fetchInputSituation();
      }
    },
    onClickAddTab() {
      this.clearMandatoryItemFilledData();

      this.selectedAddClaimType = null;
      this.tabs.push({
        title: "損種（必要情報）",
        static: true,
      });
      this.activeTab = this.tabs.length - 1;
      this.showAdditionalTab = true;

      this.$nextTick(() => this.tabScrollToRight());
    },
    addTabCancel() {
      this.tabs.pop();
      this.activeTab = this.tabs.length - 1;
      this.showAdditionalTab = false;
    },
    clearMandatoryItemFilledData() {
      this.mandatoryItemFilledData = [];
    },

    openClaimTypeAddConfirmModal() {
      this.$refs.ClaimTypeAddConfirmModal.show();
    },
    closeClaimTypeAddConfirmModal() {
      this.$refs.ClaimTypeAddConfirmModal.close();
    },

    onClickAddReportClaimType() {
      if (this.claimReportStatus.value == 1) {
        this.openClaimTypeAddConfirmModal();
      } else {
        this.callAddReportClaimType();
      }
    },

    async callAddReportClaimType() {
      this.$vs.loading();
      const res = await claimReportClaimTypeRepository.add(
        this.claimReportId,
        this.selectedAddClaimType
      );

      if (res.status == true) {
        await this.callFetch();
      } else {
        this.$vs.notify({
          title: "損種の追加に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
      this.$vs.loading.close();
    },

    async callUpdateTitle(title) {
      this.$vs.loading();
      const res = await claimReportRepository.updateOverviews(
        this.claimReportId,
        this.overviewTitle.id,
        { input_values: title, version: this.overviewTitle.version }
      );

      if (res.status == true) {
        this.overviewTitle = res.data.overview.title;

        this.$vs.notify({
          title: "タイトルを変更しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
      } else {
        this.$vs.notify({
          title: "タイトルの変更に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
      this.isEditTitle = false;
      this.$vs.loading.close();
    },

    openConfirmUpdateStatusModal(status) {
      this.claimReportStatusChangeTo = status;
      this.$refs.ConfirmUpdateStatusModal.show();
    },
    closeConfirmUpdateStatusModal() {
      this.$refs.ConfirmUpdateStatusModal.close();
    },

    async updateClaimReportStatus(status) {
      this.closeConfirmUpdateStatusModal();

      this.$vs.loading();
      const res = await claimReportRepository.updateOverviews(
        this.claimReportId,
        this.overviewStatus.id,
        { input_values: status.value, version: this.overviewStatus.version }
      );

      if (res.status == true) {
        this.claimReportStatus = status;
        this.overviewStatus = res.data.overview.status;

        this.$vs.notify({
          title: "ステータスを変更しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
      } else {
        this.$vs.notify({
          title: "ステータスの変更に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
      this.$vs.loading.close();
    },

    getClaimTypeNameById(claimReportTypeId) {
      const claimType = this.claimReportClaimTypes.find(
        element => element.id == claimReportTypeId
      );
      if (claimType) {
        return claimType.name;
      } else {
        ("");
      }
    },
    async fetchEnterpriseId() {
      const res = await enterpriseKindRepository.fetchEnterpriseId();
      if (res && res.status) {
        this.insurerEnterpriseId = res.data.insurer_enterprise_id;
      } else {
        this.$vs.notify({
          title: "法人IDの取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async fetchOverviews() {
      const res = await claimReportRepository.getOverviews(this.claimReportId);
      if (res.status == true) {
        this.overviewTitle = res.data.overview.title;
        this.overviewStatus = res.data.overview.status;
        this.ownerEnterpriseId = res.data.insurer_owner.owner_enterprise_id;

        this.titleInput = res.data.overview.title.input_values;
        this.claimReportStatus = Object.values(
          HULL_INSURANCE_CLAIM_REPORT_STATUS_LABEL
        ).find(
          element => element.value == res.data.overview.status.input_values
        );
      } else {
        this.$vs.notify({
          title: "事故ページタイトルの取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async fetchClaimTypeTab() {
      const typeRes = await claimReportClaimTypeRepository.fetchList(
        this.claimReportId
      );
      if (typeRes.status == true) {
        this.claimReportClaimTypes = typeRes.data;
        this.initializeTabs();
        typeRes.data.forEach(element => {
          this.tabs.push({
            title: element.name,
            static: false,
            claimReportTypeId: element.id,
            claimTypeId: element.claim_type_id,
          });
        });
        if (this.activeTab > this.tabs.length - 1) {
          this.activeTab = this.tabs.length - 1;
        }
        this.showAdditionalTab = false;
      } else {
        this.$vs.notify({
          title: "事故ページ損種の取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async fetchClaimTypeOptions() {
      const typeOptionRes = await claimTypeRepository.fetch({
        page: 0,
        size: 1000,
      });
      if (typeOptionRes.status == true) {
        this.completedClaimTypes = typeOptionRes.data.claim_types.filter(
          element => element.status == 4
        );
      } else {
        this.$vs.notify({
          title: "損種の取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },

    async fetchInputSituation() {
      const inputSituationRes = await claimReportRepository.fetchInputSituation(
        this.claimReportId
      );
      if (inputSituationRes.status == true) {
        if (!inputSituationRes.data.mandatory_nums) return;

        this.mandatoryItemFilledData = inputSituationRes.data.mandatory_nums.map(
          element => {
            return {
              name: this.getClaimTypeNameById(element.claim_report_type_id),
              number: element.registered_num,
              maxNumber: element.total_num,
            };
          }
        );
      } else {
        this.$vs.notify({
          title: "各損種の入力状況データの取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async callFetch() {
      this.$vs.loading();

      await this.fetchOverviews();
      await this.fetchClaimTypeTab();

      if (this.isInsuranceCompany) {
        await this.fetchClaimTypeOptions();
      }

      this.$vs.loading.close();
    },
    openDeleteModal() {
      this.$refs.DeleteModal.show();
    },
    closeDeleteModal() {
      this.$refs.DeleteModal.close();
    },

    async callDelete() {
      this.$vs.loading();
      const res = await claimReportRepository.delete(this.claimReportId);
      this.$vs.loading.close();
      if (res.status == true) {
        this.$vs.notify({
          title: "事故を削除しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
        this.toClaimReportList();
      } else {
        this.$vs.notify({
          title: "事故の削除に失敗しました。。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },

    toClaimReportList() {
      this.$router.push({
        name: "hull-insurance-claim-report-list",
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

#claim-report-view {
  .title-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    .edit-title-input-area {
      display: flex;
      align-items: center;
      flex: 1;
      .title-input {
        flex: 1;
      }
    }

    .title-text {
      margin-right: 18px;
      transition: background-color 0.3s;
      flex: 1;
      cursor: pointer;
      &:hover {
        background: $hover-background-blue;
      }
    }

    .action-button-area {
      display: flex;
      align-items: center;
      .trash-icon-button {
        background: white;
        border-radius: 6px;
        width: 34px;
        height: 34px;
        border: 1px solid $border-color1;
        display: flex;
        justify-content: center;
        color: $item-mono2;
        transition: 0.3s;
        cursor: pointer;
        &:hover {
          background: $hover-background-blue;
        }
      }
    }
  }

  .tab-container {
    background: white;
    border-radius: 8px;
    border: solid 1px $border-color5;

    .tab-content {
      padding: 30px;
    }
    .tab-button-area {
      overflow-x: scroll;
      display: flex;
      border-bottom: solid 3px $item-mono1;
      border-radius: 8px 8px 0px 0px;
      &::-webkit-scrollbar {
        display: none;
      }
      scrollbar-width: none;
    }
    .tab-button {
      padding: 10px 40px 10px 40px;
      white-space: nowrap;
      display: flex;
      border-right: solid 1px $border-color5;
      font-weight: bold;
      cursor: pointer;
      &.active {
        background: $item-mono1;
        color: white;
      }
      &.inactive {
        transition: background-color 0.3s;
        &:hover {
          background: $hover-background-blue;
        }
      }
    }
    .tab-add-button {
      padding: 10px 20px 10px 20px;
      display: flex;
      transition: background-color 0.3s;
      cursor: pointer;
      &:hover {
        background: $hover-background-blue;
      }
    }
  }
  .right-widget-area {
    padding-left: 20px;
    max-width: 300px;
  }
  .button-area {
    display: flex;
    justify-content: space-between;
    width: 320px;
    margin-top: 20px;
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
    .button {
      width: 140px;
    }
  }
}
.delete-container,
.claim-type-add-confirm-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  .button-area {
    display: flex;
    justify-content: space-between;
    width: 320px;
    margin-top: 20px;
    margin-bottom: 10px;
    .button {
      width: 140px;
    }
  }
}
</style>
